export const nddVolunteeringStats = [
    {
        'number': 5140,
        'description': 'zapojených ľudí'
    },
    {
        'number': 18670,
        'description': 'venovaných hodín'
    },
    {
        'number': 220,
        'description': 'organizácií'
    }
]
